import moment from 'moment';
import {
  EM_CRIACAO,
  AGUARDANDO_INSPECAO,
  EM_INSPECAO,
  INSPECAO_EM_ENVIO,
  INSPECAO_ENVIADA_PARCIAL,
  INSPECAO_SYNC_ERROR,
  ERRO_AO_ENVIAR_INSPECAO,
  INSPECAO_FINALIZADA,
  INSPECAO_ENVIADA_COM_SUCESSO,
  AGUARDANDO_DIGITACAO,
  EM_DIGITACAO,
  DIGITACAO_FINALIZADA,
  EXECUTADA_GDIS,
  EM_ANALISE,
} from '../../../constants/status';
import { INSPECAO_MT_BT_TIPO_SERVICO_ID } from '../../../utils';

/** Status presente no backend; ainda não exportado em constants/status.js. */
export const INSPECAO_ENVIADA_PARCIAL_COM_SUCESSO = 'INSPECAO_ENVIADA_PARCIAL_COM_SUCESSO';

/** Chave virtual do KPI que agrupa erros de envio e sincronização. */
export const KPI_KEY_ERRO_INSPECAO = 'KPI_ERRO_INSPECAO';

/** Pipeline de inspeção — ordem canônica para gráficos e filtros. */
export const INSPECAO_STATUS_ORDER = [
  EM_ANALISE,
  AGUARDANDO_INSPECAO,
  EM_INSPECAO,
  INSPECAO_EM_ENVIO,
  INSPECAO_ENVIADA_PARCIAL,
  INSPECAO_ENVIADA_PARCIAL_COM_SUCESSO,
  INSPECAO_SYNC_ERROR,
  ERRO_AO_ENVIAR_INSPECAO,
  INSPECAO_FINALIZADA,
  INSPECAO_ENVIADA_COM_SUCESSO,
];

export const STATUS_LABELS = {
  [EM_CRIACAO]: 'Em Criação',
  [EM_ANALISE]: 'Em Análise',
  [AGUARDANDO_INSPECAO]: 'Aguardando Inspeção',
  [EM_INSPECAO]: 'Em Inspeção',
  [INSPECAO_EM_ENVIO]: 'Inspeção em Envio',
  [INSPECAO_ENVIADA_PARCIAL]: 'Inspeção Enviada Parcial',
  [INSPECAO_ENVIADA_PARCIAL_COM_SUCESSO]: 'Inspeção Enviada Parcial',
  [INSPECAO_SYNC_ERROR]: 'Inspeção Error Sincronização',
  [ERRO_AO_ENVIAR_INSPECAO]: 'Erro ao enviar Inspeção',
  [INSPECAO_FINALIZADA]: 'Inspeção Finalizada',
  [INSPECAO_ENVIADA_COM_SUCESSO]: 'Inspeção Enviada com Sucesso',
  [AGUARDANDO_DIGITACAO]: 'Aguardando Digitação',
  [EM_DIGITACAO]: 'Em Digitação',
  [DIGITACAO_FINALIZADA]: 'Digitação Finalizada',
  [EXECUTADA_GDIS]: 'Executada Gdis',
  [KPI_KEY_ERRO_INSPECAO]: 'Erro ao enviar / Sync',
};

/** Chaves usadas para ler contagens flat vindas da API nos gráficos Adere. */
export const ADERE_KNOWN_STATUS_KEYS = [
  EM_CRIACAO,
  EM_ANALISE,
  ...INSPECAO_STATUS_ORDER,
  AGUARDANDO_DIGITACAO,
  EM_DIGITACAO,
  DIGITACAO_FINALIZADA,
  EXECUTADA_GDIS,
];

export const getStatusLabel = (status) => STATUS_LABELS[status] || status;

/**
 * Cards do resumo (KPI strip).
 * Parcial e erros agrupam variantes do mesmo estágio operacional.
 */
export const KPI_CARD_GROUPS = [
  { key: EM_ANALISE, statuses: [EM_ANALISE], label: STATUS_LABELS[EM_ANALISE], color: 'info' },
  {
    key: AGUARDANDO_INSPECAO,
    statuses: [AGUARDANDO_INSPECAO],
    label: STATUS_LABELS[AGUARDANDO_INSPECAO],
    color: 'info',
  },
  { key: EM_INSPECAO, statuses: [EM_INSPECAO], label: STATUS_LABELS[EM_INSPECAO], color: 'warning' },
  {
    key: INSPECAO_EM_ENVIO,
    statuses: [INSPECAO_EM_ENVIO],
    label: STATUS_LABELS[INSPECAO_EM_ENVIO],
    color: 'warning',
  },
  {
    key: INSPECAO_ENVIADA_PARCIAL,
    statuses: [INSPECAO_ENVIADA_PARCIAL, INSPECAO_ENVIADA_PARCIAL_COM_SUCESSO],
    label: STATUS_LABELS[INSPECAO_ENVIADA_PARCIAL],
    color: 'warning',
  },
  {
    key: KPI_KEY_ERRO_INSPECAO,
    statuses: [INSPECAO_SYNC_ERROR, ERRO_AO_ENVIAR_INSPECAO],
    label: STATUS_LABELS[KPI_KEY_ERRO_INSPECAO],
    color: 'error',
  },
  {
    key: INSPECAO_FINALIZADA,
    statuses: [INSPECAO_FINALIZADA],
    label: STATUS_LABELS[INSPECAO_FINALIZADA],
    color: 'success',
  },
  {
    key: INSPECAO_ENVIADA_COM_SUCESSO,
    statuses: [INSPECAO_ENVIADA_COM_SUCESSO],
    label: STATUS_LABELS[INSPECAO_ENVIADA_COM_SUCESSO],
    color: 'success',
  },
];

/** Alias usado pelos gráficos empilhados (Adere). */
export const CHART_STATUS_ORDER = INSPECAO_STATUS_ORDER;

export const STATUS_COLOR = {
  TOTAL: 'info',
  [EM_ANALISE]: 'info',
  [AGUARDANDO_INSPECAO]: 'info',
  [EM_INSPECAO]: 'warning',
  [INSPECAO_EM_ENVIO]: 'warning',
  [INSPECAO_ENVIADA_PARCIAL]: 'warning',
  [KPI_KEY_ERRO_INSPECAO]: 'error',
  [INSPECAO_FINALIZADA]: 'success',
  [INSPECAO_ENVIADA_COM_SUCESSO]: 'success',
};

export const STATUS_FILTER_OPTIONS = INSPECAO_STATUS_ORDER.map((id) => ({
  id,
  nome: STATUS_LABELS[id],
}));

export const EMPTY_RESUMO = {
  filtrado: {},
  total: {},
};

export const EMPTY_METRIC = { nsirs: 0 };

export const formatPeriodLabel = (inicio, fim) => {
  if (inicio == null || fim == null) return '';
  return `${moment(inicio).format('DD/MM/YYYY')} – ${moment(fim).format('DD/MM/YYYY')}`;
};

export const getDefaultFilter = (authData, isInspetorOnly) => ({
  inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
  fim: moment().endOf('day').valueOf(),
  inspetorId: isInspetorOnly && authData?.id ? [authData.id] : [],
});

const toArray = (v) => (Array.isArray(v) ? v : [v]);

export const normalizeFilterForApi = (filter) => {
  if (!filter || typeof filter !== 'object') return {};
  const body = {};

  if (filter.inicio != null) body.inicio = filter.inicio;
  if (filter.fim != null) body.fim = filter.fim;

  if (Array.isArray(filter.dateTypes) && filter.dateTypes.length > 0) {
    body.dateTypes = filter.dateTypes;
  }

  if (Array.isArray(filter.inspetorIds) && filter.inspetorIds.length > 0) {
    body.inspetorIds = filter.inspetorIds;
  } else if (filter.inspetorId != null && filter.inspetorId !== '') {
    body.inspetorIds = toArray(filter.inspetorId);
  }

  if (Array.isArray(filter.malhaIds) && filter.malhaIds.length > 0) {
    body.malhaIds = filter.malhaIds;
  } else if (filter.malhaId != null && filter.malhaId !== '') {
    body.malhaIds = toArray(filter.malhaId);
  }

  if (filter.gerenciaId) body.gerenciaId = filter.gerenciaId;
  if (filter.poloId) body.poloId = filter.poloId;
  if (filter.subestacaoId) body.subestacaoId = filter.subestacaoId;
  if (filter.alimentadorId) body.alimentadorId = filter.alimentadorId;
  if (filter.codigo) body.codigo = filter.codigo;

  if (Array.isArray(filter.status) && filter.status.length > 0) {
    body.status = filter.status;
  }

  if (filter.possuiAdere != null && filter.possuiAdere !== '') {
    body.possuiAdere = filter.possuiAdere;
  }

  if (Array.isArray(filter.adereMonths) && filter.adereMonths.length > 0) {
    body.adereMonths = filter.adereMonths;
  }

  body.tipoServicos =
    Array.isArray(filter.tipoServicos) && filter.tipoServicos.length > 0
      ? filter.tipoServicos
      : [INSPECAO_MT_BT_TIPO_SERVICO_ID];

  if (filter.vencimentoUrgency) {
    body.vencimentoUrgency = filter.vencimentoUrgency;
  }

  return body;
};

export const normalizeResumo = (data) => {
  if (!data || typeof data !== 'object') {
    return EMPTY_RESUMO;
  }
  return {
    filtrado: data.filtrado && typeof data.filtrado === 'object' ? data.filtrado : {},
    total: data.total && typeof data.total === 'object' ? data.total : {},
  };
};

const normalizeCount = (raw) => {
  if (raw == null) return 0;
  if (typeof raw === 'number') return raw;
  if (typeof raw === 'object' && raw.nsirs != null) return raw.nsirs;
  return 0;
};

export const getMetric = (counts, status) => ({
  nsirs: normalizeCount(counts?.[status]),
});

export const getGroupedMetric = (counts, statuses) => ({
  nsirs: (statuses || []).reduce(
    (acc, status) => acc + normalizeCount(counts?.[status]),
    0,
  ),
});

export const resolveKpiStatusFilter = (kpiKey) => {
  if (!kpiKey) return null;
  const card = KPI_CARD_GROUPS.find((item) => item.key === kpiKey);
  return card ? card.statuses : [kpiKey];
};

export const sumMetrics = (counts) => {
  if (!counts || typeof counts !== 'object') return { ...EMPTY_METRIC };
  const fromTotal = normalizeCount(counts.TOTAL);
  if (fromTotal > 0) return { nsirs: fromTotal };
  return {
    nsirs: INSPECAO_STATUS_ORDER.reduce(
      (acc, status) => acc + normalizeCount(counts[status]),
      0,
    ),
  };
};

export const resolveChartStatusOrder = (apiOrder) => {
  if (Array.isArray(apiOrder) && apiOrder.length > 0) {
    return apiOrder;
  }
  return CHART_STATUS_ORDER;
};

export const getChartColorForStatus = (status, theme) => {
  const { palette } = theme;

  const map = {
    [EM_CRIACAO]: palette.secondary?.main ?? '#9c27b0',
    [EM_ANALISE]: '#42a5f5',
    [AGUARDANDO_INSPECAO]: palette.info.main,
    [EM_INSPECAO]: '#ffa726',
    [INSPECAO_EM_ENVIO]: '#fb8c00',
    [INSPECAO_ENVIADA_PARCIAL]: '#f57c00',
    [INSPECAO_ENVIADA_PARCIAL_COM_SUCESSO]: '#ef6c00',
    [INSPECAO_SYNC_ERROR]: palette.error.main,
    [ERRO_AO_ENVIAR_INSPECAO]: '#d32f2f',
    [INSPECAO_FINALIZADA]: palette.success.main,
    [INSPECAO_ENVIADA_COM_SUCESSO]: '#2e7d32',
    [AGUARDANDO_DIGITACAO]: palette.primary.main,
    [EM_DIGITACAO]: '#5c6bc0',
    [DIGITACAO_FINALIZADA]: '#00897b',
    [EXECUTADA_GDIS]: '#1565c0',
  };

  if (map[status]) return map[status];

  const fallbackPalette = ['#7b1fa2', '#0097a7', '#c2185b', '#558b2f', '#6a1b9a', '#0277bd', '#ad1457'];
  let hash = 0;
  for (let i = 0; i < status.length; i += 1) {
    hash += status.charCodeAt(i);
  }
  return fallbackPalette[hash % fallbackPalette.length];
};

export const VENCIMENTO_MODES = {
  NEXT_7_DAYS: 'next7days',
  FILTER_RANGE: 'filterRange',
};

export const VENCIMENTO_URGENCY = {
  OVERDUE: 'overdue',
  TODAY: 'today',
  WEEK: 'week',
  MONTH: 'month',
};

export const VENCIMENTO_URGENCY_LABELS = {
  [VENCIMENTO_URGENCY.OVERDUE]: 'Vencidas',
  [VENCIMENTO_URGENCY.TODAY]: 'Hoje',
  [VENCIMENTO_URGENCY.WEEK]: 'Próximos 7 dias',
  [VENCIMENTO_URGENCY.MONTH]: 'Próximos 30 dias',
};
